module.exports = __webpack_public_path__ + "static/media/KUl.svg.1095112f.png";